import React from 'react';
import IncubatorAddCardTab from './incubatorAddCardTab';
import {Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
export default class AddCardModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { open, handleClose, addCardFunction } = this.props;
        return (
            <Dialog
                maxWidth='lg'
                fullWidth
                open={open}
                onClose={handleClose}
            >
                <DialogTitle>Link a µPub</DialogTitle>
                <DialogContent>
                <DialogContentText>This list will only display the 20 most recent µPubs. To find additional µPubs, use the search tools on the left side.</DialogContentText>
                    <IncubatorAddCardTab 
                        showAdded
                        addCardFunction={addCardFunction}
                    />
                </DialogContent>
                <DialogActions>
                <Button className="material-button" onClick={handleClose}>Close</Button>

                </DialogActions>
            </Dialog>
        );
    }
}